<template>
  <v-container style="display:flex;align-items:center;min-height:100vh">
    <div class="success-wrapper">
      <div class="circle-div">
        <!-- <v-icon color="white" x-large>mdi-check</v-icon> -->
        <img class="check-icon" src="@/assets/icon/check.svg" />
      </div>
      <div class="text-center text-h5 font-weight-bold primary--text">
        회원가입 완료
      </div>
    </div>
    <v-row>
      <v-btn
        class="text-h6 font-weight-bold"
        color="primary"
        tile
        block
        fixed
        x-large
        style="z-index: 5;left: 0;bottom: 0px;height: 56px;"
        to="/signin"
      >
        시작하기
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  created() {
    if (!this.$route.params.status) this.$router.replace('/signin')
  }
}
</script>

<style>
.success-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.circle-div {
  margin-bottom: 1rem;
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3e0ba5;
}
.check-icon {
  width: 2rem;
}
</style>
